import { AssetUrlProps } from '@cld/code-snippet-next';
import { ParsedUrlProps } from '../serverTypes';

const parsePrefix = (host: string, secure: boolean) => {
  const url = `${secure ? 'https://' : 'http://'}${host}`;
  return host.startsWith('http') ? host : url;
};

const addPostfix = (value: string) => {
  return value && `${value}/`;
};

/**
 * Conditionally concatenate type, resource_type & cloud_name:
 * Only concatenate non-empty values and if result exists in data.url
 * @param data: ParsedUrlProps
 */
const parseKind = (data: ParsedUrlProps) => {
  return [data.type, data.resource_type, data.cloud_name].filter((v) => v).reduce((a, b) => (data.url.includes(`${b}/${a}`) ? `${b}/${a}` : a)) + '/';
};

export const parseParsedUrl = (data: ParsedUrlProps): AssetUrlProps => {
  try {
    return {
      prefix: addPostfix(parsePrefix(data.host, data.secure)),
      transformation: addPostfix(data.transformation_string),
      signature: data.signature && addPostfix(`s--${data.signature}--`),
      version: data.version && addPostfix(`v${data.version}`),
      publicId: data.public_id,
      kind: parseKind(data),
    };
  } catch (err) {
    console.error(err);
    return {};
  }
};
